/**
 * Owners (Eigentümer) domain API functions (Step 7.1.11).
 *
 * List, get, create, update owners; owner-units sub-resource.
 * Extracted from adminData/index.js for team scalability.
 */
import {
  API_BASE_URL,
  getApiHeaders,
  parseAdminErrorResponse,
} from "./core";

/**
 * Owners (Eigentümer). List, get, create, update — minimal API for CRM integration.
 */
export function fetchAdminOwners() {
  return fetch(`${API_BASE_URL}/api/admin/owners`, { headers: getApiHeaders() })
    .then((res) => {
      if (!res.ok) throw new Error("Eigentümer konnten nicht geladen werden.");
      return res.json();
    })
    .then((data) => {
      if (Array.isArray(data)) {
        return { items: data, owners_with_units_count: 0 };
      }
      return {
        items: Array.isArray(data.items) ? data.items : [],
        owners_with_units_count:
          typeof data.owners_with_units_count === "number" ? data.owners_with_units_count : 0,
      };
    });
}

export function fetchAdminOwnerUnits(ownerId) {
  return fetch(
    `${API_BASE_URL}/api/admin/owners/${encodeURIComponent(ownerId)}/units`,
    { headers: getApiHeaders() }
  ).then((res) => {
    if (!res.ok) {
      if (res.status === 404) return [];
      throw new Error("Units konnten nicht geladen werden.");
    }
    return res.json();
  });
}

export function fetchAdminOwner(id) {
  const base = `${API_BASE_URL}/api/admin/owners/${encodeURIComponent(id)}`;
  const sep = base.includes("?") ? "&" : "?";
  return fetch(`${base}${sep}_=${Date.now()}`, {
    headers: getApiHeaders(),
  }).then((res) => {
    if (!res.ok) {
      if (res.status === 404) return null;
      throw new Error("Eigentümer konnte nicht geladen werden.");
    }
    return res.json();
  });
}

export async function createAdminOwner(body) {
  const res = await fetch(`${API_BASE_URL}/api/admin/owners`, {
    method: "POST",
    headers: getApiHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error(await parseAdminErrorResponse(res));
  }
  return res.json();
}

export async function patchAdminOwner(id, body) {
  const res = await fetch(`${API_BASE_URL}/api/admin/owners/${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers: getApiHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error(await parseAdminErrorResponse(res));
  }
  return res.json();
}
